import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import Select from 'react-select';
import { Alert, Button } from 'reactstrap';
import { useFetchRelistingAccounts } from '../../reusables/hooks/fetch/useFetchRelistingAccounts';
import { defaultRelistAccount } from './returnRelistForm';
import { returnErrorMessage } from './returnSale';

const ReturnRelistAccount = ({ sale, onSelect, onSearchUsers, disabled }) => {
  const { accounts, isLoading, error, retry } = useFetchRelistingAccounts();
  const [email, setEmail] = useState(null);
  const [resolving, setResolving] = useState(false);
  const [resolveError, setResolveError] = useState(null);
  const [attempt, setAttempt] = useState(0);
  const source = sale.created_source;

  useEffect(() => {
    setEmail(accounts ? defaultRelistAccount({ created_source: source }, accounts) : null);
  }, [accounts, source]);

  useEffect(() => {
    let cancelled = false;
    onSelect(null);
    setResolveError(null);
    if (!email || !accounts || !accounts.emails.includes(email)) return undefined;
    setResolving(true);
    Promise.resolve().then(() => onSearchUsers(email)).then((result) => {
      if (cancelled) return;
      if (!result || !result.ok) throw (result && result.error) || new Error('Unable to load account.');
      const page = result.data && result.data.data;
      const rows = page && page.data;
      const user = Array.isArray(rows) && rows.find((item) => item.email.toLowerCase() === email.toLowerCase());
      if (!user) {
        setResolveError('The configured account could not be found. Select another account or check Settings.');
        return;
      }
      onSelect(user);
    }).catch((err) => {
      if (!cancelled) setResolveError(returnErrorMessage(err));
    }).finally(() => { if (!cancelled) setResolving(false); });
    return () => { cancelled = true; };
  }, [email, accounts, onSelect, onSearchUsers, attempt]);

  if (isLoading) return <p>Loading Kick Avenue accounts...</p>;
  if (error) return (
    <Alert color="danger">
      {error} <Button type="button" color="secondary" size="sm" onClick={retry}>Retry</Button>
    </Alert>
  );
  return (
    <>
      <Select
        id="return-account"
        valueKey="email"
        labelKey="email"
        value={email}
        options={accounts.emails.map((item) => ({ email: item }))}
        searchable
        clearable={false}
        disabled={disabled}
        placeholder="Search Kick Avenue account..."
        onChange={(option) => setEmail(option ? option.email : null)}
      />
      {resolving ? <small className="text-muted">Loading selected account...</small> : null}
      {resolveError ? <Alert color="danger" className="mt-2">{resolveError} <Button type="button" color="secondary" size="sm" onClick={() => setAttempt((count) => count + 1)} disabled={disabled}>Retry</Button></Alert> : null}
    </>
  );
};

ReturnRelistAccount.propTypes = {
  sale: propTypes.object.isRequired,
  onSelect: propTypes.func.isRequired,
  onSearchUsers: propTypes.func.isRequired,
  disabled: propTypes.bool,
};

export default ReturnRelistAccount;
